module.exports = __webpack_public_path__ + "img/caas3m-m@1.f7caca4a.jpg";